import React, { useState, useEffect } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { AutoComplete } from 'antd';
import { DatePicker, Space } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { fetchBusCityDesDispatch } from '../../reducers/BusReducer';
import {
	setHolidayDes,
	setSelectedBusArr,
	setSelectedBusDepart,
} from '../../reducers/UiReducer';
import { useNavigate } from 'react-router-dom';
import { fetchHotelCityDispatch } from '../../reducers/HotelReducer';
import {
	fetchAllLocationDispatch,
	fetchAllPackageDispatch,
} from '../../reducers/PackageReducer';
const Option = AutoComplete.Option;
const { RangePicker } = DatePicker;

const SearchEngineHolidays = () => {
	const [departDate, setDepartDate] = useState('');
	const { buscity, busDes } = useSelector((state) => state.bus);
	const { busDepart, busArr, holdes } = useSelector((state) => state.ui);
	const { hotelcity } = useSelector((state) => state.hotel);
	const { locationresult } = useSelector((state) => state.package);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [filterData, setFilterData] = useState('');
	const [filterData2, setFilterData2] = useState('');
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const onChangeReturn: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDateReturn(dateString);
	};

	useEffect(() => {
		let formData = {};
		dispatch(fetchHotelCityDispatch(formData));
	}, []);

	const handleChange = (value) => {
		let form2 = {
			keywords: value.toLowerCase(),
		};
		dispatch(fetchAllLocationDispatch(form2));
		dispatch(setHolidayDes(value));
	};
	const opsList =
		locationresult?.result?.length > 0 &&
		locationresult?.result?.map((l) => {
			return <Option value={`${l.location}`}>{`${l.location}`}</Option>;
		});

	const handleChange2 = (value) => {
		let form2 = {
			location: value.toLowerCase(),
		};
		// dispatch(fetchAllPackageDispatch(form2));
	};
	const opsList2 =
		hotelcity?.result?.length > 0 &&
		hotelcity?.result?.map((l) => {
			return (
				<Option
					value={`${l.city_name} - ${l.country_name},${l.country_code}`}>{`${l.city_name} - ${l.country_name},${l.country_code} `}</Option>
			);
		});
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	// console.log('busDepart', busDepart.split(' ')[0]);
	const handleSubmit = () => {
		// let formData = {
		// 	departure_city: busDepart.split(' ')[0],
		// 	arrival_city: busArr.split(' ')[0],
		// 	sourceid: busDepart.split(',')[1],
		// 	destinationid: busArr.split(',')[1],
		// 	dateofjourney: departDate,
		// };
		// console.log('formData', formData);
		let form2 = {
			location: holdes?.toLowerCase(),
			// month: `${data.months.split('-')[0]}-${data.months.split('-')[1]}`,
			// location: selectedDepart.city_name.toLowerCase(),
			// location: 'goa',
			// month: `${origin.split('-')[1]}-${origin.split('-')[0]}`,
		};
		dispatch(fetchAllPackageDispatch(form2));
		navigate('/searchresultholidays', { state: form2 });
	};
	return (
		<div>
			<Grid container spacing={1}>
				<Grid item xs={12} lg={1}></Grid>
				<Grid item xs={12} lg={4}>
					<AutoComplete
						style={{ width: '100%' }}
						dropdownMenuStyle={{
							maxHeight: 1000,
							overflowY: 'visible',
						}}
						placeholder='Where do you want to travel?'
						onClick={(e) => console.log('val', e.target.value)}
						onChange={handleChange}>
						{opsList}
					</AutoComplete>
				</Grid>
				<Grid item xs={12} lg={3}>
					<DatePicker
						picker='month'
						disabledDate={disabledDate}
						style={{ width: '100%', padding: 9 }}
					/>
				</Grid>
				<Grid item xs={12} lg={3}>
					<Button
						onClick={handleSubmit}
						variant='contained'
						style={{
							width: '100%',
							background: 'orange',
							fontWeight: 'bold',
							padding: '7px',
						}}>
						Search
					</Button>
				</Grid>
				<Grid item xs={12} lg={1}></Grid>
			</Grid>
		</div>
	);
};

export default SearchEngineHolidays;
